import { SITE_ID } from "application/constants/app-constants";
import { endsWith, mergeRight, startsWith } from "ramda";
import getTokenId from "../inetgeco/getTokenId";
import getCountry from "module/functions/getCountry";
import getLang from "module/functions/getLang";
const country = getLang() || getCountry();
const language = country ?? "gb";

const countries = ["fr"];

const _locale = language === "gb" || !countries.includes(language) ? "en" : language;

export default function getHeaders() {
  const siteHeader = { "X-Site-Id": SITE_ID, auth_token: getTokenId() };
  const localeHeader = { "Accept-language": getLocaleForHeaders() };
  const requiredHeaders = mergeRight(siteHeader, localeHeader);
  return requiredHeaders;
}

const getLocaleForHeaders = () => {
  const locale = _locale;
  if (startsWith("zh", locale)) {
    const auxLocale = locale.toLocaleLowerCase();
    if (endsWith("hant", auxLocale) || endsWith("hk", auxLocale) || endsWith("tw", auxLocale)) {
      return "zh-TW";
    }
    return "zh-CN";
  }
  return locale;
};
